import classNames from "classnames";
import React from "react";
import type { ReactNode } from "react";
import "./LayoutCell.scss";

export interface LayoutCellProps {
  /**Used to change style Component */
  className?: string;
  /** Option to align display value */
  position?: "left" | "right" | "center";
  children: ReactNode;
}

function LayoutCell(props: LayoutCellProps) {
  const { className, children, position = "left" } = props;
  return (
    <div
      className={classNames(
        className,
        `layout-cell`,
        `layout-cell-position-${position}`
      )}
    >
      {children}
    </div>
  );
}
export default LayoutCell;
